export default "/packs/images/500x400~adcd5b55409c323fc059678caf5d836e.jpg";